/* eslint-disable @typescript-eslint/no-floating-promises */
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { en } from "../locales";

const resources = {
  en: {
    translation: en,
  },
};

i18next.use(initReactI18next).init({
  debug: true,
  lng: "en",
  fallbackLng: "en",
  resources,
});

export default i18next;
